import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, TextField, Button, IconButton, Tooltip, Chip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';

const API = axios.create({ baseURL: '/api' });
API.interceptors.request.use(c => { const t = localStorage.getItem('dashboard_token'); if (t) c.headers['Authorization'] = 'Bearer ' + t; return c; });

export default function BlacklistPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState({ telegram_id: '', telegram_username: '', reason: '' });

  const load = () => API.get('/blacklist').then(r => { setList(r.data); setLoading(false); });
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.telegram_id) return;
    await API.post('/blacklist?' + new URLSearchParams(form));
    setDialog(false); setForm({ telegram_id: '', telegram_username: '', reason: '' });
    load();
  };

  const remove = async (tid) => {
    if (!window.confirm('Видалити з чорного списку?')) return;
    await API.delete('/blacklist/' + tid);
    setList(l => l.filter(x => x.telegram_id !== tid));
  };

  return (
    <Box>
      <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
        <Typography variant="h5" sx={{ color:'#fff', fontWeight:'bold' }}>🚫 Чорний список</Typography>
        <Button variant="contained" startIcon={<AddIcon/>} onClick={() => setDialog(true)} sx={{ bgcolor:'#f44336' }}>Додати</Button>
      </Box>
      {list.length === 0 ? <Box sx={{ textAlign:'center', p:3 }}><Typography sx={{ color:'#888', bgcolor:'rgba(26,26,46,0.7)', borderRadius:2, px:2, py:1, display:'inline-block' }}>Список порожній</Typography></Box> :
        list.map(u => (
          <Paper key={u.id} sx={{ bgcolor:'#1a1a2e', border:'1px solid #f44336', p:2, mb:1, display:'flex', alignItems:'center', gap:2 }}>
            <BlockIcon sx={{ color:'#f44336' }}/>
            <Box sx={{ flexGrow:1 }}>
              <Typography variant="body1" sx={{ color:'#fff' }}>@{u.telegram_username || '?'} <Chip label={'ID: '+u.telegram_id} size="small" sx={{ bgcolor:'rgba(244,67,54,0.2)', color:'#f44' }}/></Typography>
              {u.reason && <Typography variant="caption" sx={{ color:'#888' }}>Причина: {u.reason}</Typography>}
              <Typography variant="caption" sx={{ color:'#555', display:'block' }}>{u.created_at?.substring(0,10)}</Typography>
            </Box>
            <Tooltip title="Видалити з ЧС">
              <IconButton size="small" onClick={() => remove(u.telegram_id)} sx={{ color:'#555','&:hover':{color:'#f44'} }}><DeleteIcon/></IconButton>
            </Tooltip>
          </Paper>
        ))
      }
      <Dialog open={dialog} onClose={() => setDialog(false)}>
        <DialogTitle sx={{ bgcolor:'#1a1a2e', color:'#fff' }}>🚫 Додати в чорний список</DialogTitle>
        <DialogContent sx={{ bgcolor:'#1a1a2e', display:'flex', flexDirection:'column', gap:2, pt:2 }}>
          <TextField label="Telegram ID *" value={form.telegram_id} onChange={e => setForm({...form, telegram_id: e.target.value})}
            sx={{ input:{color:'#fff'}, '& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}, label:{color:'#aaa'} }}/>
          <TextField label="Username" value={form.telegram_username} onChange={e => setForm({...form, telegram_username: e.target.value})}
            sx={{ input:{color:'#fff'}, '& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}, label:{color:'#aaa'} }}/>
          <TextField label="Причина" value={form.reason} onChange={e => setForm({...form, reason: e.target.value})}
            sx={{ input:{color:'#fff'}, '& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}, label:{color:'#aaa'} }}/>
        </DialogContent>
        <DialogActions sx={{ bgcolor:'#1a1a2e' }}>
          <Button onClick={() => setDialog(false)} sx={{ color:'#aaa' }}>Скасувати</Button>
          <Button onClick={add} variant="contained" sx={{ bgcolor:'#f44336' }}>Додати</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}